import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const FeaturedCenterManagementHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'> Feature Centers</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default FeaturedCenterManagementHeader;
